// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1de21c49","453":"7ee157c4"}[chunkId] + ".chunk.js";
};